import { render, staticRenderFns } from "./PasswordChangeStatus.vue?vue&type=template&id=3aa33a34&"
import script from "./PasswordChangeStatus.vue?vue&type=script&lang=js&"
export * from "./PasswordChangeStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports